<template>
  <div class="v-list-empty-search">
    <div class="v-list-empty-search__title">{{ emptyTitle }}</div>
    <div class="divider"></div>
    <div class="v-list-empty-search__message">
      <v-icon class="mr-1" color="icon" small>mdi-information</v-icon>
      {{ $t("generic.select_dropdown.create_resource", { resource: $tc(`resources.${resourceName}.name`, 1) }) }}
      <span @click="createResource(resourceName)" class="v-list-empty-search__message__resource">
        <v-icon class="ml-1" color="primary" small>mdi-open-in-new</v-icon>
        {{ $tc(`resources.${resourceName}.name`, 2) }}.
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "EmptySelectSearchList",
    props: {
      resourceName: {
        type: String,
        default: "",
      },
      emptyTitle: {
        type: String,
        default: "",
      },
    },
    methods: {
      createResource(resourceName) {
        let resource;
        // Resource name in back calls modals, but in dashboard we showed him like popups
        if (resourceName === "popups") {
          resource = "modals";
        } else {
          resource = resourceName;
        }
        this.$emit("click", resource);
      },
    },
  };
</script>
